// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5608) return "static/chunks/5608-3734ce2504a06a84.js";
	if (chunkId === 2505) return "static/chunks/2505-32775a343316b5ce.js";
	if (chunkId === 9784) return "static/chunks/9784-7858e027deac2bb5.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5540":"81c7cf9d93893809","6435":"9124ad0db7854218","7338":"3e9d94d4b3830618","9097":"519bdeb28aa08eae"}[chunkId] + ".js";
};